<template>
    <div class="component-wrap">
        <form class="reset-form md-elevation-5 reset-form" @submit.prevent="resetPassword">
        
        <img srcset="@/assets/img/tcs_logo_1x.png 1x, @/assets/img/tcs_logo_2x.png 2x"
            alt="Logo Image"
            class="reset-form__logo">

        <h1 class="md-title reset-form__title">Enter new password</h1>

       <AppInput 
            required
            class="reset-form__field"
            type="password"
            placeholder="Password"
            v-model="$v.password.$model"
            :error="$v.password.$invalid && $v.password.$dirty"
            :errorText="chooseErrorText($v.password)"
        />

        <AppInput 
            required
            class="reset-form__field"
            type="password"
            placeholder="Confirm password"
            v-model="$v.confirmPassword.$model"
            :error="$v.confirmPassword.$invalid && $v.confirmPassword.$dirty"
            :errorText="chooseErrorText($v.confirmPassword)"
        />

        <div v-if="errorMsg" class="reset-form__error">
            {{ errorMsg }}
        </div>

        <md-button class="md-primary md-raised reset-form__submit-btn"
                    :type="'submit'"
                    :disabled="$v.$invalid || loading">
            <span v-if="!loading">Reset</span>
            <span v-else>Processing...</span>
        </md-button>
    </form>
	</div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { $axios } from '@/plugins/axios'

export default {
    name: 'ResetPasswordPage',
    data: () => ({
        password: '',
        confirmPassword: '',
        loading: false,
        errorMsg: '',
    }),
    validations: {
        password: { 
            required,
            minLength: minLength(6)
        },
        confirmPassword: {
            required,
            sameAsPassword: sameAs('password')
        }
    },
    methods: {
        async resetPassword() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.loading = true;
            this.errorMsg = '';
            try {
                const nonce = this.$route.params.id;
                await $axios.put('/auth/users/password', {
                    nonce,
                    password: this.password,
                });
                this.$router.push('/login');
            } catch (error) {
                this.errorMsg = 'Unable to reset password. Please try again.';
            } finally {
                this.loading = false;
            }
        },
        chooseErrorText(field) {
            if (!field.required) {
                return 'Field is required';
            }

            if (!field.minLength) {
                return 'Password is too short';
            }

            if (!field.sameAsPassword) {
                return 'Passwords must be identical.';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.reset-form{
    @include default-auth-form;
}
.reset-form__error {
    color: #d32f2f;
    margin: 12px 0 0;
}
</style>